
import '../scss/style.scss';
import App from './app';
import logoIcon from '../img/logo-icon.svg';
import gridImg from '../img/grid-img.jpg';
import gridImg1 from '../img/grid/desat/grid-img-1.jpg';
import gridImg2 from '../img/grid/desat/grid-img-2.jpg';
import gridImg3 from '../img/grid/desat/grid-img-3.jpg';
import gridImg4 from '../img/grid/desat/grid-img-4.jpg';
import gridImg5 from '../img/grid/desat/grid-img-5.jpg';
import gridImg6 from '../img/grid/desat/grid-img-6.jpg';
import gridImg7 from '../img/grid/desat/grid-img-7.jpg';
import gridImg8 from '../img/grid/desat/grid-img-8.jpg';
import gridImg9 from '../img/grid/desat/grid-img-9.jpg';
import gridImg10 from '../img/grid/desat/grid-img-10.jpg';
import gridImg11 from '../img/grid/desat/grid-img-11.jpg';
import gridImg12 from '../img/grid/desat/grid-img-12.jpg';
import gridImg13 from '../img/grid/desat/grid-img-13.jpg';
import gridImg14 from '../img/grid/desat/grid-img-14.jpg';
import gridImg15 from '../img/grid/desat/grid-img-15.jpg';
import gridImg16 from '../img/grid/desat/grid-img-16.jpg';
import gridImg17 from '../img/grid/desat/grid-img-17.jpg';
import gridImg18 from '../img/grid/desat/grid-img-18.jpg';
import gridImg19 from '../img/grid/desat/grid-img-19.jpg';
import gridImg20 from '../img/grid/desat/grid-img-20.jpg';
import gridImg21 from '../img/grid/desat/grid-img-21.jpg';
import gridImg22 from '../img/grid/desat/grid-img-22.jpg';
import gridImg23 from '../img/grid/desat/grid-img-23.jpg';
import bearModel from '../img/bp2.glb'
import bearModel2 from '../img/bp2-4-comp.glb'
import bearModel3 from '../img/bp2-3.glb'
import bearStanding from '../img/bp-standing.glb'
import noiseTexture from '../img/noise.png'
import hiveModel from '../img/bp2-hive.glb'
import hiveModel2 from '../img/bp2-hive-2.glb'
import hiveModel3 from '../img/bp2-hive-3.glb'
import envMappx from '../img/px7.png'
import envMapnx from '../img/nx7.png'
import envMappy from '../img/py7.png'
import envMapny from '../img/ny7.png'
import envMappz from '../img/pz7.png'
import envMapnz from '../img/nz7.png'
import particleTexture from '../img/star_06.png'

const app = new App();